import { camelizeKeys } from 'humps';
import { CALL_API } from '../../middleware/api';
import { setToken, getToken, deleteToken } from '../../auth';
import { loadCart } from './cart';
import { recalculate } from './basket';

const LOGIN = 'user/LOGIN';
const LOGIN_SUCCESS = 'user/LOGIN_SUCCESS';
const LOGIN_FAIL = 'user/LOGIN_FAIL';

const LOAD = 'user/LOAD';
const LOAD_SUCCESS = 'user/LOAD_SUCCESS';
const LOAD_FAIL = 'user/LOAD_FAIL';

export const LOGOUT = 'user/LOGOUT';
const SET_COMPANY = 'user/SET_COMPANY';


export const setCompany = (company=null, persist=true) => (dispatch, getState) => {
  if (!company) {
    const { companies } = getState().user.user;

    if (localStorage.lastCompany) {
      const id = parseInt(localStorage.lastCompany, 10);
      company = companies.find(c => c.id === id);
    }

    // can't find pick first.
    if (!company) {
      company = companies[0];
    }
  }

  // remember company
  if (persist) {
    localStorage.lastCompany = company.id;
  }

  dispatch({
    type: SET_COMPANY,
    company
  });
  dispatch(recalculate());
  return dispatch(loadCart())
}

export const logOut = () => dispatch => {
  dispatch({ type: LOGOUT });
  deleteToken();
}

export const loadUser = () => (dispatch, getState) => {
  if (!getState().user.user && getToken()) {
    return dispatch({
      [CALL_API]: {
        types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
        endpoint: 'user/',
        method: 'GET',
      }
    }).then(_ => dispatch(setCompany()));
  }
}

export const logIn = (email, password) => (dispatch, getState) => {
  return dispatch({
    [CALL_API]: {
      types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
      endpoint: 'auth/',
      method: 'POST',
      payload: {
        username: email,
        password
      }
    }
  }).then(result => {
    setToken(result.response.token);
    return dispatch(setCompany());
  });
}

export const logInFromResponse = response => (dispatch) => {
  dispatch({
    type: LOGIN_SUCCESS,
    response: response
  });
  setToken(response.token);
  return dispatch(setCompany());
};


const initialState = {
  user: null,
  loginErrors: {},
  company: null,
};


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: camelizeKeys(action.response.user)
      }
    case LOGIN_FAIL:
      return {
        ...state,
        loginErrors: action.error
      }

    case LOAD_SUCCESS:
      return {
        ...state,
        user: camelizeKeys(action.response)
      }

    case SET_COMPANY:
      return {
        ...state,
        company: action.company
      }

    case LOGOUT:
      return {
        ...state,
        user: null,
        company: null
      }

    default: 
      return state
  }
};


// WEBPACK FOOTER //
// ./src/redux/modules/user.js